export const useStyles = (theme) => ({
  root: {
    padding: 20,
  },
  body: {
    display: "flex",
    alignItems: "space-between",
    justifyContent: "space-between",
  },
  content: {
    fontSize: 16,
    display: "flex",
    alignItems: "center",
    marginLeft: 60,
    [theme.breakpoints.down(700)]: {
      marginLeft: 20,
    },
  },
});
